function n(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
export {
  n as default
};
//# sourceMappingURL=index.js.map
